import { useEffect, useMemo, useState } from "react";
import SiteSettingForm from "../../components/Dashboard/SiteSettingForm";
import Loader from "../../components/UI/Loader";
import { useApp } from "../../context/AppContext";
import { getSiteSettings, upsertSiteSettings } from "../../services/siteService";

const SettingsPage = () => {
  const { siteSettings, currentSite, settingsMap, updateSiteSettings } = useApp();
  const defaultSiteSettings = {
    site_name: siteSettings?.siteName || "",
    tagline: siteSettings?.siteTagline || "",
    whatsapp_number: siteSettings?.whatsappNumber || "",
    email: siteSettings?.contactEmail || "",
    instagram_url: siteSettings?.socialLinks?.instagram || "",
    tiktok_url: siteSettings?.socialLinks?.tiktok || "",
    address: siteSettings?.address || "",
    hero_title: siteSettings?.heroTitle || "",
    hero_subtitle: siteSettings?.heroSubtitle || "",
    logo: siteSettings?.logo || "",
    favicon: siteSettings?.favicon || "",
    primary_color: siteSettings?.primaryColor || "#8e1628",
    secondary_color: siteSettings?.secondaryColor || "#ec4899",
    maps_embed_url: settingsMap?.maps_embed_url || "",
  };
  const [initialSettings, setInitialSettings] = useState(defaultSiteSettings);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const formInitialValues = useMemo(
    () => ({ ...defaultSiteSettings, ...initialSettings }),
    [defaultSiteSettings, initialSettings]
  );

  const fetchSettings = async () => {
    setLoading(true);
    setError("");
    try {
      const data = await getSiteSettings();
      const site = data?.site || {};
      const settingsMap = data?.settings_map || {};

      setInitialSettings({
        site_name: site.name || "",
        whatsapp_number: site.whatsapp_number || "",
        email: site.email || "", // Pastikan email diambil dari level site
        address: site.address || "",
        logo: site.logo || "",
        favicon: site.favicon || "",
        primary_color: site.primary_color || "",
        secondary_color: site.secondary_color || "",
        tagline: settingsMap.tagline || "",
        instagram_url: settingsMap.instagram_url || "",
        tiktok_url: settingsMap.tiktok_url || "",
        hero_title: settingsMap.hero_title || "",
        hero_subtitle: settingsMap.hero_subtitle || "",
        maps_embed_url: settingsMap.maps_embed_url || "",
      });
    } catch (err) {
      setError(err.message || "Gagal memuat pengaturan.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

const handleSubmit = async (form) => {
    setSaving(true);
    setError("");
    setSuccessMessage("");

    try {
      const payload = {
        site_name: form.site_name,
        whatsapp_number: form.whatsapp_number,
        email: form.email, 
        address: form.address,
        logo: form.logo,
        favicon: form.favicon,
        primary_color: form.primary_color,
        secondary_color: form.secondary_color,
        settings: {
          tagline: form.tagline,
          instagram_url: form.instagram_url,
          tiktok_url: form.tiktok_url,
          hero_title: form.hero_title,
          hero_subtitle: form.hero_subtitle,
          maps_embed_url: form.maps_embed_url,
        }
      };

      await upsertSiteSettings(payload);
      
      setSuccessMessage("Pengaturan berhasil disimpan ke Database!");
      setTimeout(() => setSuccessMessage(""), 3000);

      await fetchSettings();

      // Perbaikan error refreshSiteData
      updateSiteSettings({
        siteName: form.site_name,
        siteTagline: form.tagline,
        whatsappNumber: form.whatsapp_number,
        contactEmail: form.email,
        address: form.address,
        heroTitle: form.hero_title,
        heroSubtitle: form.hero_subtitle,
        logo: form.logo,
        favicon: form.favicon,
        primaryColor: form.primary_color,
        secondaryColor: form.secondary_color,
        socialLinks: { instagram: form.instagram_url, tiktok: form.tiktok_url },
      });
      
    } catch (err) {
      // PERBAIKAN: Ambil pesan error asli dari backend
      const serverError = err.response?.data?.detail || err.message;
      if (err.response?.status === 401) {
        setError("Sesi login berakhir. Silakan login kembali sebagai Admin.");
      } else {
        setError(serverError || "Gagal menyimpan pengaturan.");
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "24px" }}>
      <div className="admin-page-header" style={{ marginBottom: "24px" }}>
        <h2 style={{ color: "#8e1628", fontWeight: "800" }}>🔧 Pengaturan Website</h2>
      </div>

      {loading && <Loader text="Menghubungkan ke database..." />}
      {error && <div style={{ color: "#b91c1c", padding: "12px", background: "#fee2e2", borderRadius: "8px", marginBottom: "20px" }}>⚠️ {error}</div>}
      {successMessage && <div style={{ color: "#166534", padding: "12px", background: "#dcfce7", borderRadius: "8px", marginBottom: "20px" }}>✅ {successMessage}</div>}

      {!loading && (
        <SiteSettingForm
          initialValues={formInitialValues}
          onSubmit={handleSubmit}
          loading={saving}
        />
      )}
    </div>
  );
};

export default SettingsPage;